// The classic site's session and this tab (decided 2026-10-30).
//
// Step 1 offers "Continue as {name}" when the browser is logged in to the classic site as an actor
// (an agent's or a casting account's session is never offered). "Not you? Use another account"
// there, and "Not you? Log out" at the bottom of steps 2–4, both mean the same thing: for this
// tab, that classic session isn't the visitor, so step 1 shows the usual form from then on. The
// classic site itself is never logged out from here.

const DISMISSED_KEY = "sfClassicSessionDismissed.v1";

export const isClassicSessionDismissed = (): boolean => {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const dismissClassicSession = () => {
  try {
    window.sessionStorage.setItem(DISMISSED_KEY, "1");
  } catch (e) {
    // Without storage the card can come back on step 1; "Not you?" hides it again.
  }
};

// How long step 1 waits for the answer before showing the form anyway. A visitor with no classic
// session gets a 401 at once (about 85 ms on integration); a session takes 160–650 ms, then the
// account's name another 100–300. So this only bounds a slow sign-in service.
export const CLASSIC_SESSION_WAIT_MS = 3000;

export const withTimeout = <T>(promise: Promise<T>, ms: number, fallback: T): Promise<T> =>
  new Promise((resolve) => {
    const timer = setTimeout(() => resolve(fallback), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      () => {
        clearTimeout(timer);
        resolve(fallback);
      }
    );
  });
